import { ErrorResponse } from "./AppResponse";

// type ActionError = { result: ErrorResponse };

export const isActionError = (error: any): error is ErrorResponse => {
  return error && "errors" in error;
};
